import React from 'react'
import "../Styles/About.css"
import Title from "../Components/Utils/Title"



function About() {
  return (
    <div id='About'>

      <h1 id='Title'>ABOUT ME</h1>

      <div id='Contents'>

        <div id='Info'>
          <h3>
            &#160;&#160;&#160;&#160;I am a Full Stack Developer with hands-on experience in building scalable web applications using the MERN stack.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;I have worked on real-world projects such as OTA systems and SIL Automation applications during my internships.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;I enjoy developing secure, efficient, and user-friendly frontend and backend solutions.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;I am continuously learning modern web technologies to improve performance and code quality.
          </h3>
          {/* <h3>
            &#160;&#160;&#160;&#160;Hi, I’m Paramesh Kumar S, a passionate and self-driven Full Stack Developer with a strong foundation in web technologies and real-world project experience. I recently completed my B.E. in Computer Science and Engineering and gained hands-on development exposure through internships at Expleo Group and NovaNectar Services.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;I’ve built and deployed full-stack applications like an Over-the-Air (OTA) Update System using React.js, Node.js, Express.js, and MySQL, and designed my own Portfolio website to showcase my work. I enjoy turning ideas into functional, user-friendly web solutions, and I’m continuously exploring better ways to write clean and scalable code.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;I’m currently seeking full-time opportunities as a Web Developer or Full Stack Developer, where I can grow, collaborate, and make an impact through code.
          </h3>
          <h3>
            &#160;&#160;&#160;&#160;When I’m not coding, you’ll find me experimenting with new tech, diving into strategy games, or enjoying cricket with friends. Let’s connect and build something awesome!
          </h3> */}
        </div>

        <div id='MyImg'></div>

      </div>


    </div>
  )
}

export default About